import Modal from 'antd-mobile/lib/modal';
export default Modal;



// WEBPACK FOOTER //
// ./components/modal/index.tsx